import React from 'react';

import SmartChip from 'ui-library/chips/SmartChip';
import useSmartChipQuery, {ChipItem, SmartChipType} from 'ui-library/chips/useSmartChipQuery';
import {FolderItemIcon} from 'ui-library/icons/IconConstants';

import {getSharedSmartChipProps, SharedSmartChipProps} from './ChipUtil';

export interface TemplateChipProps extends SharedSmartChipProps<SmartChipType.TEMPLATE> {
  id: string;
}

export default function TemplateChip(props: TemplateChipProps): JSX.Element {
  const sharedSmartChipProps = getSharedSmartChipProps(props);
  const {id, onClick} = sharedSmartChipProps;

  const {
    item: template,
    handleClickLink,
    isInaccessible,
    itemUrl,
  } = useSmartChipQuery<SmartChipType.TEMPLATE>({
    id,
    onClick,
    getUrlFn: ({editUrl}) => editUrl,
  });

  return (
    <SmartChip
      {...sharedSmartChipProps}
      icon={FolderItemIcon.Template}
      isInaccessible={isInaccessible}
      item={template}
      onClick={handleClickLink}
      url={itemUrl}
      getSecondaryText={getSecondaryText}
    />
  );
}

export function getSecondaryText(template: ChipItem<SmartChipType.TEMPLATE>): string | null {
  return null;
}
